import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { Page } from "src/app/model/Page";
import { RegistrationModerationAuditTrailModel } from "src/app/model/RegistrationModerationAuditTrailModel";
import { RegistrationModerationModel } from "src/app/model/RegistrationModerationModel";
import { ModerationService } from "src/app/services/moderation.service";
import { ModerationAuditTrailComponent } from "../moderation-audit-trail/moderation-audit-trail.component";

@Component({
  selector: "app-secure-moderation-audit-trail-list",
  templateUrl: "./moderation-audit-trail-list.component.html",
  styleUrls: ["./moderation-audit-trail-list.component.scss"],
})
export class ModerationAuditTrailListComponent implements OnInit, AfterViewInit {
  registrationModerationAuditTrailList: Page<RegistrationModerationAuditTrailModel>;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<RegistrationModerationAuditTrailModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicantName",
    "panNumber",
    "maskedAadhaarNumber",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private moderationService: ModerationService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.registrationModerationAuditTrailList = null;
    this.dataSource = new MatTableDataSource(null);
    setTimeout(() => {
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.isLoading = true;
      this.moderationService.fetchModerationAuditTrail(this.currentPage, this.pageSize, this.filterForm.value.filterText).subscribe((page) => {
          this.isLoading = false;
          this.registrationModerationAuditTrailList = page;
          this.dataSource = new MatTableDataSource(page.content);
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for Audit Trail", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onSearch();
  }

  async onViewAuditTrail(registrationId: number) {
    this.moderationService.fetchModerationDocumentAuditTrail(registrationId).subscribe(async (data) => {
      const modal = await this.modalCtrl.create({
        component: ModerationAuditTrailComponent,
        cssClass: 'master-modal',
        componentProps: {
            moderationAuditTrail: data
        }
      });
      modal.present();
    });
  }
}